<div class="mainBG" appScrollChaining>
  <!-- mblSlideBg -->
  <!-- @if (isSignedIn) {
    <div class="mblSlideBg" [ngClass]="{'active': isMobileMenuActive}">
      <div class="mblSlideBg__header">
        <span></span>
        <span class="closeIcon" (click)="isMobileMenuActive = !isMobileMenuActive">
          <img ngSrc="assets/images/closeWhite.svg" alt="" width="24" height="24">
        </span>
      </div>
      <div class="mblSlideBg__menu">
        <ul>
          <li>
            <a href="javascript:void(0)" routerLink="/home">
              <label>{{'Home'| translate}}</label>
              <img ngSrc="assets/images/menuIcon1.svg" alt="" width="24" height="24">
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" routerLink="/play-golf" routerLinkActive="active">
              <label>{{'PlayGolf' | translate}}</label>
              <img ngSrc="assets/images/playGolf.svg" alt="" width="24" height="24">
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" routerLink="/discover">
              <label>{{'Discover' | translate}}</label>
              <img ngSrc="assets/images/menuIcon2.svg" alt="" width="24" height="24">
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="navigateToSettingPage('MyBag')">
              <label>{{'MyBag' | translate}}</label>
              <img ngSrc="assets/images/menuIcon4.svg" alt="" width="24" height="24">
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="navigateToSettingPage('MyPartner')">
              <label>{{'My'| translate}} <b>{{'GolfAI' | translate}}</b></label>
              <img ngSrc="assets/images/myGolf.svg" alt="" width="24" height="24">
            </a>
          </li>
        </ul>
        <div class="txtArea">
          <h6>{{'EnhanceYourGame' | translate}} <br>
            {{'With' | translate}} <span>{{'GolfAI' | translate}}</span></h6>
            <p>
              + {{'ChooseYourPartner' | translate}}<br>
              + {{'UploadGolfBag' | translate}}<br>
              + {{'PartnerComingSoon' | translate}}<br>
              + {{'BetterYourGame' | translate}}<br>
            </p>
          </div>
        </div>
        <div class="profileBg">
          <span class="profile" (click)="navigateToSettingPage('MySettings')" [class.noImage]="!user()?.imageUrl">
            @if (user()?.imageUrl) {
              <img [src]="user()?.imageUrl" alt="">
            }
            @if (!user()?.imageUrl) {
              <div class="profile-letter">{{user()?.name?.substring(0, 2)?.toUpperCase()}}
              </div>
            }
          </span>
          <label (click)="navigateToSettingPage('MySettings')" class="col">My Settings</label>
        </div>
      </div>
    } -->
    <!-- mblSlideBg -->
    <!-- mobileMenu -->

    <div
      class="container golf-wrap content-area"
      [class.landing-theme]="isLandingRoute"
      [class.hide-header]="isSignedIn">
        <!-- topMenu -->
            <!-- <div class="topMenu" *ngIf="isSignedIn">
                <div class="logoBg">
                    <a href="javascript:void(0)" routerLink="/home" class="d-none d-md-block">
                        <img class="top-logo" src="assets/images/logo.svg" alt="Golf AI" class="d-md-none">
                    </a>
                    <span (click)="navigateToSettingPage('MySettings')" class="d-md-none">
                        <img *ngIf="user()?.imageUrl" [src]="user()?.imageUrl" alt="">
                        <div *ngIf="!user()?.imageUrl">{{user()?.name?.substring(0, 2)?.toUpperCase()}}</div>
                    </span>
                </div>
                <div class="mainLogo signed-logo">
                    <img src="assets/images/logo.svg" alt="Golf AI" class="">
                </div>
                <div class="d-inline-flex">
                    <a href="javascript:void(0)" class="mblIcon d-md-none d-inline-block"
                        (click)="isMobileMenuActive = !isMobileMenuActive">
                        <img src="assets/images/hamBugerIcon.svg" alt="">
                    </a>
                </div>
            </div> -->
            <app-header></app-header>
            
            <!-- menuBlock -->        
        <!-- topMenu -->

    <!-- menuBlock -->
    <!-- topMenu -->


    <div class="row cont-block">
      <div class="col left_block">
        <div class="d-block h-100">
          <router-outlet></router-outlet>
        </div>
      </div>

      <!-- voiceResponse-block -->
      <!-- bg-white voiceResponse-block -->
      <div class="col-auto chat-col">
        <app-chat-box></app-chat-box>
      </div>
      <!-- voiceResponse-block -->
    </div>

  </div>



</div>



<!-- <ng-template #authModal>
<app-auth-modal
  [inEmbeddedBrowser]="inEmbeddedBrowser"
  [page]="authPage"
  [loadCaddy]="loadCaddyData"
  (closeModal)="closeAuthModal($event)">
</app-auth-modal>
</ng-template> -->

<ng-template #courseInvitationModal>
  <div class="courseInvitationModal">
    <div class="courseInvitationModal__header">
      @if (!businessClaimed) {
        <h5>You're invited</h5>
      } @else {
        <h5>Claimed successfully</h5>
      }
    </div>
    <div class="courseInvitationModal__body">
      @if (!businessClaimed) {
        <p>You've been invited to manage courses under <br><b>{{ invitedBusinessName }}</b>. <br>Please claim your access now.</p>
        <button class="common-btn mt-3" [disabled]="claimModalSubmitting" (click)="onClaimNow()">
          @if (claimModalSubmitting) {
            <img class="loading-img" src="assets/images/processing_white.svg">
          } @else {
            Claim now
          }
        </button>
      } @else {
        <p>Your access has been activated. You can now manage courses for <b>{{ invitedBusinessName }}</b>.</p>
        <button class="common-btn borderBtn mt-3 me-3" (click)="closeClaimModal()">Close</button>
        <button class="common-btn mt-3" (click)="goToCoursePortal()">
          @if (claimModalSubmitting) {
            <img class="loading-img" src="assets/images/processing_white.svg">
          } @else {
            Go to Courses
          }
        </button>

      }
    </div>
  </div>
</ng-template>